// extracted by mini-css-extract-plugin
export default {"navbar":"NavBar_navbar__4+Elm","mains":"NavBar_mains__9lbdF","textwrapper":"NavBar_textwrapper__EJwdR","name":"NavBar_name__f2eHC","active":"NavBar_active__LcSWU"};